












































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
const TemplateEdit = () => import("./template-edit.vue");
import TemplateRead from "./template-read.vue";
@Component({
  components: {
    TemplateEdit,
    TemplateRead,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifShow: any;
  @Prop()
  private tableData: any;
  @Watch("tableData", { immediate: true })
  private tableDataChange() {
    if (this.tableData) {
      this.data = JSON.parse(JSON.stringify(this.tableData));
    }
  }
  private data: any = [];
  private ifShowErji: any = false;
  private erjiData: any = {};
  private moban: any = [];
  private hangIndex: any = -1;
  private lieIndex: any = -1;
  private addOne() {
    this.data = [[{}]];
    this.$forceUpdate();
  }
  private addHang(index: any) {
    // 生成一行数据
    let arr: any = [];
    this.data[0].forEach((ele: any) => {
      arr.push({});
    });
    // 在目标行后面插入一行
    this.data.splice(index + 1, 0, arr);
  }
  private delHang(index: any) {
    this.data.splice(index, 1);
  }
  private addLie(index: any) {
    this.data.forEach((ele: any) => {
      ele.splice(index + 1, 0, {});
    });
  }
  private delLie(index: any) {
    this.data.forEach((ele: any) => {
      ele.splice(index, 1);
    });
  }
  private addOneCell(hangIndex: any, lieIndex: any) {
    this.hangIndex = hangIndex;
    this.lieIndex = lieIndex;
    this.erjiData = {
      type: "主标题",
    };
    this.moban = [];
    this.ifShowErji = true;
  }
  private editOneCell(hangIndex: any, lieIndex: any) {
    this.hangIndex = hangIndex;
    this.lieIndex = lieIndex;
    this.erjiData = JSON.parse(JSON.stringify(this.data[hangIndex][lieIndex]));
    this.moban = [this.erjiData];
    this.ifShowErji = true;
  }
  private delOneCell(hangIndex: any, lieIndex: any) {
    this.data[hangIndex][lieIndex] = {};
    this.$forceUpdate();
  }
  private updateErjiData(e: any) {
    this.data[this.hangIndex][this.lieIndex] = JSON.parse(JSON.stringify(e[0]));
    this.ifShowErji = false;
  }
  private cancel() {
    this.$emit("cancel");
  }
  private makeSure() {
    this.$emit("update", this.data);
  }
}
